<template>
  <div class="breadcrumb">
    <div class="left"><i class="iconfont icon-user1"></i>{{ name }}</div>
    <div class="right">
      <el-button class="back" plain size="small" icon="el-icon-arrow-left" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'headerTitel',
    props: {
      name: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="less" scoped>
  .breadcrumb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    padding-bottom: 10px;
    border-bottom: 1px solid #dcdfe6;
    .left {
      font-size: 14px;
      .iconfont {
        margin-right: 5px;
        color: #cccccc;
      }
    }
    .right {
      .back {
        font-size: 12px;
        width: 70px;
        height: 26px;
        line-height: 25px;
        padding: 0;
        text-align: center;
      }
    }
  }
</style>
